import { useQueryClient } from "@tanstack/react-query"
import { getRouteApi } from "@tanstack/react-router"
import { useMemo } from "react"
import { userQueryOptions } from "../auth/user-query"
import type { User } from "./types"

const rootRoute = getRouteApi("__root__")

/**
 * Snapshot of the current user from `byId`, or null without an account.
 * Taken again when the account changes; it does not follow cache updates.
 * Use where the account is not guaranteed (onboarding, selfie flow).
 */
export function useCurrentUserSnapshotOrNull(): User | null {
	const { userId } = rootRoute.useRouteContext()
	const queryClient = useQueryClient()
	return useMemo(() => {
		if (userId === null) return null
		const cached = queryClient.getQueryData(userQueryOptions(userId).queryKey)
		if (!cached) return null
		return cached
	}, [queryClient, userId])
}
